var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2574,
    cy: 13.9996,
    r: 13.4996,
    stroke: "#6C584C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9297 11.3281C17.9906 11.3281 19.008 11.7496 19.7581 12.4997C20.5083 13.2498 20.9297 14.2673 20.9297 15.3281V19.9948H18.263V15.3281C18.263 14.9745 18.1225 14.6354 17.8725 14.3853C17.6224 14.1353 17.2833 13.9948 16.9297 13.9948C16.5761 13.9948 16.2369 14.1353 15.9869 14.3853C15.7368 14.6354 15.5964 14.9745 15.5964 15.3281V19.9948H12.9297V15.3281C12.9297 14.2673 13.3511 13.2498 14.1013 12.4997C14.8514 11.7496 15.8688 11.3281 16.9297 11.3281Z",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2526 12H7.58594V20H10.2526V12Z",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91927 9.99479C9.65565 9.99479 10.2526 9.39784 10.2526 8.66146C10.2526 7.92508 9.65565 7.32812 8.91927 7.32812C8.18289 7.32812 7.58594 7.92508 7.58594 8.66146C7.58594 9.39784 8.18289 9.99479 8.91927 9.99479Z",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIc);
export default __webpack_public_path__ + "static/media/LINKEDIN_ic.c0255e21a7972612a908040613d365dc.svg";
export { ForwardRef as ReactComponent };